/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CalculationParameterUnit } from './CalculationParameterUnit';
import {
    CalculationParameterUnitFromJSON,
    CalculationParameterUnitFromJSONTyped,
    CalculationParameterUnitToJSON,
    CalculationParameterUnitToJSONTyped,
} from './CalculationParameterUnit';
import type { CalculationParameterKey } from './CalculationParameterKey';
import {
    CalculationParameterKeyFromJSON,
    CalculationParameterKeyFromJSONTyped,
    CalculationParameterKeyToJSON,
    CalculationParameterKeyToJSONTyped,
} from './CalculationParameterKey';
import type { CalculationParameterEntryResponse } from './CalculationParameterEntryResponse';
import {
    CalculationParameterEntryResponseFromJSON,
    CalculationParameterEntryResponseFromJSONTyped,
    CalculationParameterEntryResponseToJSON,
    CalculationParameterEntryResponseToJSONTyped,
} from './CalculationParameterEntryResponse';

/**
 * 
 * @export
 * @interface CalculationParameterResponse
 */
export interface CalculationParameterResponse {
    /**
     * 
     * @type {CalculationParameterKey}
     * @memberof CalculationParameterResponse
     */
    key: CalculationParameterKey;
    /**
     * 
     * @type {string}
     * @memberof CalculationParameterResponse
     */
    technicalKey: string;
    /**
     * 
     * @type {CalculationParameterUnit}
     * @memberof CalculationParameterResponse
     */
    unit: CalculationParameterUnit;
    /**
     * 
     * @type {Array<CalculationParameterEntryResponse>}
     * @memberof CalculationParameterResponse
     */
    entries: Array<CalculationParameterEntryResponse>;
}



/**
 * Check if a given object implements the CalculationParameterResponse interface.
 */
export function instanceOfCalculationParameterResponse(value: object): value is CalculationParameterResponse {
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('technicalKey' in value) || value['technicalKey'] === undefined) return false;
    if (!('unit' in value) || value['unit'] === undefined) return false;
    if (!('entries' in value) || value['entries'] === undefined) return false;
    return true;
}

export function CalculationParameterResponseFromJSON(json: any): CalculationParameterResponse {
    return CalculationParameterResponseFromJSONTyped(json, false);
}

export function CalculationParameterResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CalculationParameterResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'key': CalculationParameterKeyFromJSON(json['key']),
        'technicalKey': json['technicalKey'],
        'unit': CalculationParameterUnitFromJSON(json['unit']),
        'entries': ((json['entries'] as Array<any>).map(CalculationParameterEntryResponseFromJSON)),
    };
}

export function CalculationParameterResponseToJSON(json: any): CalculationParameterResponse {
    return CalculationParameterResponseToJSONTyped(json, false);
}

export function CalculationParameterResponseToJSONTyped(value?: CalculationParameterResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key': CalculationParameterKeyToJSON(value['key']),
        'technicalKey': value['technicalKey'],
        'unit': CalculationParameterUnitToJSON(value['unit']),
        'entries': ((value['entries'] as Array<any>).map(CalculationParameterEntryResponseToJSON)),
    };
}

